import axios from "axios";


export const superAdminAddUser = (data: any) => axios.post(`super/users/admin`, data)

export const superAdminEditUser = (data: any) => axios.patch(`super/users/${data.userId}`, data)


